import JobZImage from "../jobz-img";
import { NavLink } from "react-router-dom";
import { publicUser } from "../../../globals/route-names";
import {enLangTranslation, uaLangTranslation} from "../../../globals/constants";

function Footer1() {
    const lang = localStorage.getItem('language') || 'en';
    const uaLang = uaLangTranslation;
    const enLang = enLangTranslation;
    const translation = lang === 'en' ? enLang : uaLang;

    return (
        <>
            <footer className="footer-light">
                <div className="container">
                    {/* FOOTER BLOCKES START */}
                    <div className="footer-top">
                        <div className="row">
                            <div className="col-lg-3 col-md-12">
                                <div className="widget widget_about">
                                    <div className="logo-footer clearfix">
                                        <NavLink to={publicUser.HOME1}><JobZImage id="skin_footer_dark_logo" src="images/logo.svg" alt="" /></NavLink>
                                    </div>
                                    <p>{translation.footer.description}</p>
                                </div>
                            </div>
                            <div className="col-lg-9 col-md-12">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="widget widget_services ftr-list-center">
                                            <h3 className="widget-title">{translation.footer.linksTitle}</h3>
                                            <ul>
                                                <li><a href="/#home">{translation.footer.links.home}</a></li>
                                                <li><a href="/#expertise">{translation.footer.links.expertise}</a></li>
                                                <li><a href="/#about">{translation.footer.links.about}</a></li>
                                                <li><a href="/#work">{translation.footer.links.process}</a></li>
                                                <li><a href="/#job-offer">{translation.footer.links.vacancies}</a></li>
                                                <li><a href="/#testimonials">{translation.footer.links.reviews}</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="widget widget_services ftr-list-center">
                                            <h3 className="widget-title">{translation.footer.contactsTitle}</h3>
                                            <ul className="ftr-list">
                                                <li><p><span>Email :</span>recruiting@inovation.solutions</p></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* FOOTER COPYRIGHT */}
                    <div className="footer-bottom">
                        <div className="footer-bottom-info">
                            <div className="footer-copy-right">
                                <span
                                    className="copyrights-text">Copyright © 2025 InOvation. All Rights Reserved.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer1;